import { forwardRef, type SVGProps } from 'react';

export const MoneyIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(
  function MoneyIcon(props, ref) {
    return (
      <svg
        ref={ref}
        viewBox="0 0 24 19"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M3.6 3.5625V11.875C3.6 13.185 4.67625 14.25 6 14.25H21.6C22.9238 14.25 24 13.185 24 11.875V3.5625C24 2.25254 22.9238 1.1875 21.6 1.1875H6C4.67625 1.1875 3.6 2.25254 3.6 3.5625ZM6 9.5C7.32375 9.5 8.4 10.565 8.4 11.875H6V9.5ZM8.4 3.5625C8.4 4.87246 7.32375 5.9375 6 5.9375V3.5625H8.4ZM21.6 9.5V11.875H19.2C19.2 10.565 20.2763 9.5 21.6 9.5ZM19.2 3.5625H21.6V5.9375C20.2763 5.9375 19.2 4.87246 19.2 3.5625ZM10.8 7.71875C10.8 6.93139 11.1161 6.17628 11.6787 5.61953C12.2413 5.06278 13.0044 4.75 13.8 4.75C14.5956 4.75 15.3587 5.06278 15.9213 5.61953C16.4839 6.17628 16.8 6.93139 16.8 7.71875C16.8 8.50611 16.4839 9.26122 15.9213 9.81797C15.3587 10.3747 14.5956 10.6875 13.8 10.6875C13.0044 10.6875 12.2413 10.3747 11.6787 9.81797C11.1161 9.26122 10.8 8.50611 10.8 7.71875ZM1.8 4.45312C1.8 3.95957 1.39875 3.5625 0.9 3.5625C0.40125 3.5625 0 3.95957 0 4.45312V13.3594C0 15.8197 2.01375 17.8125 4.5 17.8125H19.5C19.9988 17.8125 20.4 17.4154 20.4 16.9219C20.4 16.4283 19.9988 16.0312 19.5 16.0312H4.5C3.0075 16.0312 1.8 14.8363 1.8 13.3594V4.45312Z"
          fill="currentColor"
        />
      </svg>
    );
  },
);
